import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Button, ButtonSize, ButtonVariant, IconAnimation, IconName, IconSize, } from '@as/cotopaxi';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { wishListActions } from '../../redux/wishList/actions/WishListActions.creators';
import { makeIsProductInWishList } from '../../redux/wishList/selectors/WishListSelectors';
export const WishlistButton = ({ productCode, productId, colourId, skuId, buttonProps, onToggle, }) => {
    const { isShopLanding } = useAemConfig();
    const shouldAnimate = useRef(false);
    const dispatch = useDispatch();
    const inWishList = useSelector(makeIsProductInWishList(productCode, colourId));
    const mergedButtonProps = Object.assign(Object.assign({}, buttonProps), { icon: Object.assign({ name: inWishList ? IconName.HEART : IconName.HEART_EMPTY, size: IconSize.MEDIUM, animation: shouldAnimate.current ? IconAnimation.HEART_PULSE : undefined }, ((buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.icon) || {})) });
    const handleWishListToggle = () => {
        shouldAnimate.current = !inWishList;
        dispatch(wishListActions.toggleProduct({
            colorId: colourId,
            productCode,
            productId,
            sku: skuId,
        }));
        onToggle === null || onToggle === void 0 ? void 0 : onToggle();
    };
    if (isShopLanding) {
        return null;
    }
    return (_jsx(Button, Object.assign({ dataQA: "add_to_wishlist", variant: ButtonVariant.INVERSE_ALT, size: ButtonSize.XSMALL, onClick: handleWishListToggle }, mergedButtonProps)));
};
